import { Row, Col } from "antd";
import { useAtomValue } from "jotai/utils";

import FilterBox from "./filter-box";

import { useMemo } from "react";

import subjectsAtom from "../../data/atoms/subjects";

function FacetedSearchSubjects({ sortByHits, ...restProps }) {
  // const searchFacets = useAtomValue(searchFacetsAtom);
  const subjects = useAtomValue(subjectsAtom);

  const subjectsFilters = useMemo(() => {
    // console.log("but here first", searchFacets.subjects);
    if (subjects.data) {
      const filters = [...subjects.data];

      // for (const subject of subjects.data) {
      //   if (searchFacets.subjects[subject.label]) {
      //     filters.push({
      //       ...subject,
      //       hits: searchFacets.subjects[subject.label],
      //     });
      //   }
      // }

      if (sortByHits === true)
        filters.sort((a, b) => {
          return b.hits - a.hits;
        });
      return filters.filter(subject => subject.hits > 0);
    }

    return [];
  }, [subjects, sortByHits]);

  return (
    <Row gutter={[14, 14]} {...restProps}>
      {subjectsFilters.map((subject) => (
        <Col key={subject.code} xs={12} sm={8} md={6} xl={4}>
          <FilterBox
            href={`/concept/${subject.code}/`}
            label={subject.name}
            image={{ url: subject.image, mime: "image/svg+xml" }}
            color={subject.meta.color}
            extra={`${subject.hits} ${subject.hits > 1 ? "results" : "result"}`}
            aria-label={`Show ${subject.hits} ${subject.hits > 1 ? "results" : "result"} for ${subject.name}`}
          />
        </Col>
      ))}
    </Row>
  );
}
export default FacetedSearchSubjects;
